import React, { useEffect, useState } from "react";
import Select, { default as ReactSelect, components } from "react-select";
// import makeAnimated from "react-select/animated";
import axios from "axios";
import { HOST_URL, WhstappAccountList } from "../../api/Api";
import Axios from "../../../../axios/Axios";
import { CAMPAIGN_CONTACT_LIST_API } from "../../../../constants/ServiceConstants";

function NewButton(props) {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  let paramid = props.paramid;
  let whatsappNumber = props.brandNumber
  // console.log(props)
  // const animatedComponents = makeAnimated();
  const [defaultButtnData, setdefaultButtnData] = useState();
  const [callToAction, setCallToAction] = useState(false);
  const [specialUser, setSpecialUser] = useState("");
  const [urlAction, setUrlAction] = useState(false);
  const [urlAction2, setUrlAction2] = useState(false);
  const [quickReply, setQuickReply] = useState(false);
  const [buttonType, setButtonType] = useState({
    callToAction: false,
    quickReply: false,
    flow: false,
  });
  const [flowAction, setFlowAction] = useState({ text: "", actionType: "FLOW", flow_id: "" });
  const [enableFlowOption, setEnableFlowOption] = useState(false);
  const [flowOptionValue, setFlowOptionValue] = useState("");
  const [contactList, setContactList] = useState([]);
  const [contactListLoading, setContactListLoading] = useState(false);
  const [flows, setFlows] = useState([]);
  const [flowsLoading, setFlowsLoading] = useState(false);
  const [isChecked, setisChecked] = useState(false);
  const [quickRepCount, setQuickRepCount] = useState(1);
  const [selectedOption, setSelectedOption] = useState([""]);
  const [selectedButtonOption, setSelectedButtonOption] = useState([]);
  const [selectedQuickReplyOption, setSelectedQuickReplyOption] = useState([""])
  const [button1, setButton1] = useState(false)
  const [button2, setButton2] = useState(false)
  const [button3, setButton3] = useState(false)
  const [button4, setButton4] = useState(false)
  const [button5, setButton5] = useState(false)
  const [button6, setButton6] = useState(false)
  const [button7, setButton7] = useState(false)
  const [isButtonChecked, setIsButtonChecked] = useState(false);
  const [mainUrl, setMainurl] = useState('')
  // const [whatsappNumber, setWhatsappNumber] = useState([])
  // const [url, setUrl] = useState('');

  const handleChange = (event) => {
    const checked = event.target.checked;
    setIsButtonChecked(checked);

    if (checked) {
      if (urlAction?.urlType === "Dynamic") {
        setUrlAction((prevState) => ({
          ...prevState,
          url: `https://0kb.in/${whatsappNumber}/`
        }))
      }
      else if (urlAction2?.urlType === "Dynamic") {
        setUrlAction2((prevState) => ({
          ...prevState,
          url: `https://0kb.in/${whatsappNumber}/`
        }))
      }

    } else {
      if (urlAction?.urlType === "Dynamic") {
        setUrlAction((prev) => ({
          ...prev,
          url: "",
        }));
      }
      else if (urlAction2?.urlType === "Dynamic") {
        setUrlAction2((prev) => ({
          ...prev,
          url: "",
        }));
      }
    }
  };


  useEffect(() => {
    if (paramid !== undefined) {
      setisChecked(true);
      setdefaultButtnData(props.defaultButtnData);
      updateData(props.defaultButtnData)
      updateInnerData(props.defaultButtnData)
      if (props.defaultButtnData?.length > 0) {
        // setButtonType("call to action");
        props.defaultButtnData.map((item) => {
          let key = Object.keys(item);
          if (key.includes("urltext")) {
            setUrlAction(item);
          }
          if (key.includes("urltext2")) {
            setUrlAction2(item);
          }
          if (key.includes("phone")) {
            setCallToAction(item);
          }
          if (key.includes("button1")) {
            setButton1(item)
          }
          if (key.includes("button2")) {
            setButton2(item)
          }
          if (key.includes("button3")) {
            setButton3(item)
          }
          if (key.includes("button4")) {
            setButton4(item)
          }
          if (key.includes("button5")) {
            setButton5(item)
          }
          if (key.includes("button6")) {
            setButton6(item)
          }
          if (key.includes("button7")) {
            setButton7(item)
          }
        });

        // if (props.defaultButtnData[0].actionType === "quickReply") {
        //   setButtonType("quick reply");

        //   const convertObjectToArray = (obj) => {
        //     return Object.keys(obj).map(key => ({ [key]: obj[key] }));
        //   };

        //   const transformedArray = convertObjectToArray(props.defaultButtnData[0]);
        //   const removeActionType = (arr) => {
        //     return arr.filter(item => !Object.keys(item).includes("actionType"));
        //   };

        //   const filteredArray = removeActionType(transformedArray);
        //   setQuickReply(props.defaultButtnData[0]);
        //   setQuickRepCount(filteredArray.length);
        // }
      }
    }
  }, [props.defaultButtnData, paramid]);

  useEffect(() => {
    if (!Array.isArray(props.defaultButtnData)) {
      return;
    }
    props.defaultButtnData.forEach((item) => {
      const keyys = Object.keys(item);
      if (keyys.includes("phone")) {
        const newObj = { value: "callphone", label: "Call Phone number" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("urltext")) {
        const newObj = { value: "visitwebsite1", label: "Visit website 1" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("urltext2")) {
        const newObj = { value: "visitwebsite2", label: "Visit website 2" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button1")) {
        const newObj = { value: "button1", label: "Button 1" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button2")) {
        const newObj = { value: "button2", label: "Button 2" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button3")) {
        const newObj = { value: "button3", label: "Button 3" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button4")) {
        const newObj = { value: "button4", label: "Button 4" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button5")) {
        const newObj = { value: "button5", label: "Button 5" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button6")) {
        const newObj = { value: "button6", label: "Button 6" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("button7")) {
        const newObj = { value: "button7", label: "Button 7" };
        setSelectedQuickReplyOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
    });
  }, [props.defaultButtnData]);

  useEffect(() => {
    setIsButtonChecked(props.checkedButton);
    setMainurl(props.mainurl)
  }, [props.checkedButton, props.mainurl])

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    let paramData = {
      user_id: userId,
      method: "retrieve",
      token: userToken
    }
    let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
    if (data.data.success === true) {
      setSpecialUser(data.data.data);
    }
  }

  const buttonHandler = (selectedButtonOptions) => {
    const selectedValues = selectedButtonOptions.map(option => option.value);
    setButtonType({
      callToAction: selectedValues.includes("call to action"),
      quickReply: selectedValues.includes("quick reply"),
      flow: selectedValues.includes("flow"),
    });

    // Only clear state for types that are no longer selected
    if (!selectedValues.includes("call to action")) {
      props.sendButtonData(false);
      props.sendURLButton(false);
      setCallToAction(false);
      setUrlAction(false);
      setUrlAction2(false);
    }

    if (!selectedValues.includes("quick reply")) {
      setQuickReply(false);
    }

    if (!selectedValues.includes("flow")) {
      setFlowAction({ text: "", actionType: "FLOW", flow_id: "" });
    }

    setButtonValue();
  };

  // console.log(flowAction);
  

  // useEffect(() => {
  //   getWhatsaAppNumberList();
  // }, [])

  // const getWhatsaAppNumberList = async () => {
  //   let paramData = {
  //     user_id: userId,
  //     token: userToken,
  //     method: "retrieve",
  //   }
  //   WhstappAccountList(paramData).then((res) => {
  //     if (res.data.success === true) {
  //       // console.log(res.data.data)
  //       setWhatsappNumber(res.data.data[0].brand_number)
  //     } else {
  //       console.log("data not fetch")
  //     }
  //   });
  // };



  const buttonHnadlar = (event) => {
    event.target.checked ? setisChecked(true) : setisChecked(false);
  };

  const setQuickButtonValue = () => {
    const buttonData = {
      button1,
      button2,
      button3,
      button4,
      button5,
      button6,
      button7,
      isButtonChecked,
      mainUrl
    };


    // Call the function passed from the parent
    props.sendQuickReplyButtonData(buttonData);
  };

  useEffect(() => {
    setQuickButtonValue();
  }, [button1, button2, button3, button4, button5, button6, button7, mainUrl, isButtonChecked]);

  const setButtonValue = () => {
    props.sendButtonData([callToAction]);
    props.sendURLButton([urlAction]);
    props.sendURLButton2([urlAction2]);
    props.sendQuickButton([quickReply]);
    if (props.sendFlowButton) props.sendFlowButton(flowAction);
  };

  useEffect(() => {
    setButtonValue();
  }, [callToAction, urlAction, urlAction2, quickReply, flowAction]);

  useEffect(() => {
    if (props.sendFlowOption) {
      props.sendFlowOption({
        enabled: enableFlowOption,
        contactListId: flowOptionValue,
        flowMetaId: flowAction.flow_id,
      });
    }
  }, [enableFlowOption, flowOptionValue, flowAction.flow_id]);

  const changeHandler = (e) => {
    setCallToAction({
      ...callToAction,
      [e.target.name]: e.target.value,
      actionType: "calltoaction",
    });
  };

  const urlHandler = (e) => {

    setUrlAction((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      actionType: "calltoaction",
    }));

    if (e?.traget?.value === 'Dynamic') {
      if (e.target.value === "Static") {
        setIsButtonChecked(false);
        setUrlAction((prev) => ({
          ...prev,
          url: ""
        }));
      }
    }
  };

  const urlHandler2 = (e) => {
    setUrlAction2((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      actionType: "calltoaction",
    }));

    if (e?.traget?.value === 'Dynamic') {
      if (e.target.value === "Static") {
        setIsButtonChecked(false);
        setUrlAction2((prev) => ({
          ...prev,
          url: ""
        }));
      }
    }
  };

  useEffect(() => {
    if (buttonType.flow && flows.length === 0) {
      fetchFlows();
    }
  }, [buttonType.flow]);

  const fetchFlows = async () => {
    setFlowsLoading(true);
    try {
      const { data } = await Axios.post(
        'https://napi3.authkey.io/api2/v1/user/flow',
        { user_id: userId, token: userToken, method: 'retrieve_flow' }
      );
      if (data.success) {
        setFlows(Array.isArray(data.message) ? data.message : []);
      }
    } catch (err) {
      console.error('Failed to load flows', err);
    } finally {
      setFlowsLoading(false);
    }
  };

  const fetchContactList = async () => {
    setContactListLoading(true);
    try {
      const { data } = await Axios.post(CAMPAIGN_CONTACT_LIST_API, {
        token: userToken,
        user_id: userId,
        method: "retrieve",
      });
      if (data.success === true) {
        setContactList(data.data);
      }
    } catch (err) {
      console.error('Failed to load contact list', err);
    } finally {
      setContactListLoading(false);
    }
  };

  const flowHandler = (e) => {
    setFlowAction((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      actionType: "FLOW",
    }));
  };

  const handleFlowSelect = (e) => {
    const selectedFlow = flows.find((f) => String(f.meta_flow_id) === e.target.value);
    setFlowAction((prev) => ({
      ...prev,
      text: flowAction.flowText,
      flow_id: selectedFlow ? String(selectedFlow.meta_flow_id) : "",
      actionType: "FLOW",
    }));
  };

  // console.log(flowAction);
  

  const onChangeButton1 = (e) => {
    setButton1({ ...button1, [e.target.name]: e.target.value, actionType: "quickReply" });
  }

  const onChangeButton2 = (e) => {
    setButton2({ ...button2, [e.target.name]: e.target.value, actionType: "quickReply" });
  }

  const onChangeButton3 = (e) => {
    setButton3({ ...button3, [e.target.name]: e.target.value, actionType: "quickReply" });
  }

  const onChangeButton4 = (e) => {
    setButton4({ ...button4, [e.target.name]: e.target.value, actionType: "quickReply" });
  }
  const onChangeButton5 = (e) => {
    setButton5({ ...button5, [e.target.name]: e.target.value, actionType: "quickReply" });
  }
  const onChangeButton6 = (e) => {
    setButton6({ ...button6, [e.target.name]: e.target.value, actionType: "quickReply" });
  }
  const onChangeButton7 = (e) => {
    setButton7({ ...button7, [e.target.name]: e.target.value, actionType: "quickReply" });
  }

  const addQuickRepInput = (e) => {
    if (quickRepCount < 3) {
      setQuickRepCount(quickRepCount + 1);
    }
  };

  const handleSelect = (selectedValue) => {
    setSelectedOption(selectedValue);
    if (selectedValue.length === 0) {
      setCallToAction(false);
      setUrlAction(false);
      setUrlAction2(false);
      return;
    }

    let stringArray = JSON.stringify(selectedValue);

    let phoneTextIndex = stringArray.indexOf("callphone");
    let urlTextIndex = stringArray.indexOf("visitwebsite1");
    let urlTextIndex2 = stringArray.indexOf("visitwebsite2");

    if (phoneTextIndex === -1) {
      setCallToAction(false);
    }

    if (urlTextIndex === -1) {
      setUrlAction(false);
    }
    if (urlTextIndex2 === -1) {
      setUrlAction2(false);
    }
  };

  const handleQuickReplySelect = (selectedValue) => {
    setSelectedQuickReplyOption(selectedValue);
    // if (selectedValue.length === 0) {
    //   setCallToAction(false);
    //   setUrlAction(false);
    //   setUrlAction2(false);
    //   return;
  }

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
    }),
  };

  const buttonSelectHandler = (selectedButtonOptions) => {
    setSelectedButtonOption(selectedButtonOptions || []);
  };

  const options = [
    { value: "call to action", label: "Call To Action" },
    { value: "quick reply", label: "Quick Reply" },
    { value: "flow", label: "Flow" },
  ];

  const quickReplyOption = [
    { value: "button1", label: "Button 1" },
    { value: "button2", label: "Button 2" },
    { value: "button3", label: "Button 3" },
    { value: "button4", label: "Button 4" },
    { value: "button5", label: "Button 5" },
    { value: "button6", label: "Button 6" },
    { value: "button7", label: "Button 7" },
  ]

  // useEffect(()=>{
  //   updateData();
  // },[])

  const updateData = (data) => {
    if (paramid) {
      if (data?.length > 0) {
        data.forEach((item) => {
          let keys = Object.keys(item);

          let updatedButtonType = {};

          if (keys.includes("text") || keys.includes("urltext") || keys.includes("urltext2")) {
            buttonType.callToAction = true;
          }
          if (keys.includes("button1") || keys.includes("button2") || keys.includes("button3") || keys.includes("button4") || keys.includes("button5") || keys.includes("button6") || keys.includes("button7")) {
            buttonType.quickReply = true;
          }

          // setButtonType((prevButtonType) => ({
          //   ...prevButtonType,
          //   ...updatedButtonType,
          // }));
        });
      }
    }
  };


  const updateInnerData = (data) => {
    if (paramid !== undefined) {
      setisChecked(true);
      // setdefaultButtnData(props.defaultButtnData);

      // Initialize state with the default button data based on the `paramid`
      if (props.defaultButtnData?.length > 0) {
        const buttonData = props.defaultButtnData;
        buttonData.map((x) => {
          setButton1(x.button1);
          setButton2(x.button2);
          setButton3(x.button3);
          setButton4(x.button4);
          setButton5(x.button5);
          setButton6(x.button6);
          setButton7(x.button7);
          setCallToAction(x.phone);
          setUrlAction(x.urltext);
          setUrlAction2(x.urltext2);

          // if(buttonType.callToAction === true){
          //   setButtonType({
          //     callToAction: selectedValues.includes("call to action"),
          //     // quickReply: selectedValues.includes("quick reply"),
          //   });
          // }

          // if(buttonType.quickReply=== true){
          //   setButtonType({
          //     // callToAction: selectedValues.includes("call to action"),
          //     quickReply: selectedValues.includes("quick reply"),
          //   });
          // }
        })
        // if (buttonData) {

        //   // Set other states as needed...
        // }
      }
    }
  }

  return (
    <>
      <div className="whatsapp-options">
        <label>
          <h4>
            Button<span className="text-muted">(optional)</span>
          </h4>
          <p>
            Create buttons that let customers respond to your message or take
            action.
          </p>
        </label>
        <label className="switch">
          <input
            type="checkbox"
            defaultChecked={isChecked === true ? "checked" : null}
            onChange={buttonHnadlar}
          />
          <span className="slider round"></span>
        </label>
      </div>
      {isChecked && (
        <>
          <div className="input-group drop-down-icons">
            <Select
              options={options}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isMulti
              components={{ Option }}
              styles={{
                ...buttonType,
                menuPortal: base => ({ ...base, zIndex: 9999 })
              }}
              classNamePrefix="select"
              placeholder="Select button type"
              onChange={buttonHandler}
              menuPortalTarget={document.body}
            />
          </div>

          {buttonType.callToAction && (
            <div className="call-action-area" style={{ position: 'relative', zIndex: 1 }}>
              <Select
                options={
                  specialUser === 26
                    ? [
                      { value: "callphone", label: "Call Phone number" },
                      { value: "visitwebsite1", label: "Visit website 1" }
                    ]
                    : [
                      { value: "callphone", label: "Call Phone number" },
                      { value: "visitwebsite1", label: "Visit website 1" },
                      { value: "visitwebsite2", label: "Visit website 2" }
                    ]
                }
                closeMenuOnSelect={false}
                value={selectedOption}
                hideSelectedOptions={false}
                isMulti
                components={{ Option }}
                styles={{
                  ...customStyles,
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                classNamePrefix="select"
                placeholder="Select type of action"
                onChange={handleSelect}
                menuPortalTarget={document.body}
              />

              {selectedOption.map((option) => {
                if (option.value === "callphone") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="p-2"> Call phone number </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="text"
                            value={callToAction.text}
                            onChange={changeHandler}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="countryCode"
                            value={callToAction.countryCode}
                            onChange={changeHandler}
                            placeholder="country code"
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="phone"
                            value={callToAction.phone}
                            onChange={changeHandler}
                            placeholder="Mobile Number"
                            maxLength={15}
                          />
                        </div>
                      </div>
                    </>
                  );
                }

                if (option.value === "visitwebsite1") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="p-2"> Visit website 1 </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="urltext"
                            value={urlAction.urltext}
                            onChange={urlHandler}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4 drop-down-icons">
                          <select
                            value={urlAction?.urlType}
                            onChange={urlHandler}
                            name="urlType"
                            className="form-control"
                          >
                            <option>URL Type</option>
                            <option>Static</option>
                            <option>Dynamic</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            onChange={urlHandler}
                            name="url"
                            value={
                              isButtonChecked && urlAction?.urlType === "Dynamic"
                                ? `https://0kb.in/${whatsappNumber}/`
                                : urlAction.url
                            }
                            disabled={isButtonChecked && urlAction?.urlType === "Dynamic"}
                            className="form-control"
                            placeholder="www.example.com"
                          />
                        </div>
                      </div>
                      {urlAction?.urlType === "Dynamic" && (
                        <div className="input-group mt-1 mr-sm-1">
                          <div className="input-group-text">{"{{1}}"}</div>
                          <input
                            type="text"
                            value={urlHandler2.sampleurl}
                            name="sampleurl"
                            required
                            onChange={urlHandler}
                            placeholder="Sample Data of {{1}}"
                            className="form-control"
                          />
                        </div>
                      )}
                      {urlAction?.urlType === "Dynamic" && (
                        <div className="row mt-2">
                          <div className="col-4">
                            <div className="input-group ml-4 mt-1 mr-sm-1">
                              <input
                                type="checkbox"
                                checked={isButtonChecked}
                                onChange={handleChange}
                                className="form-check-input"
                              />
                              <label className="form-check-label ml-2">Cta Tracking</label>
                            </div>
                          </div>

                          {isButtonChecked && (
                            <div className="col-8">
                              <input
                                type="text"
                                name="enter_main_url"
                                value={mainUrl}
                                required
                                onChange={(e) => setMainurl(e.target.value)}
                                placeholder="Enter Main Url"
                                className="form-control"
                              />
                            </div>
                          )}
                        </div>
                      )}

                    </>
                  );
                }

                if (option.value === "visitwebsite2") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="p-2"> Visit website 2 </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="urltext2"
                            value={urlAction2.urltext2}
                            onChange={urlHandler2}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4 drop-down-icons">
                          <select
                            value={urlAction2?.urlType}
                            onChange={urlHandler2}
                            name="urlType"
                            className="form-control"
                          >
                            <option>URL Type</option>
                            <option>Static</option>
                            <option>Dynamic</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            onChange={urlHandler2}
                            name="url"
                            value={urlAction2.url}
                            // disabled={isButtonChecked && urlAction2?.urlType === "Dynamic"}
                            className="form-control"
                            placeholder="www.example.com"
                          />
                        </div>
                      </div>
                      {urlAction2?.urlType === "Dynamic" && (
                        <div className="input-group mt-1 mr-sm-1">
                          <div className="input-group-text">{"{{1}}"}</div>
                          <input
                            type="text"
                            name="sampleurl"
                            value={urlHandler2.sampleurl}
                            required
                            onChange={urlHandler2}
                            placeholder="Sample Data of {{1}}"
                            className="form-control"
                          />
                        </div>
                      )}

                    </>
                  );
                }

                return null;
              })}
            </div>
          )}

          {buttonType.quickReply && (
            <div>
              <div className="call-action-area" style={{ position: 'relative', zIndex: 1 }}>
                <Select
                  options={quickReplyOption}
                  closeMenuOnSelect={false}
                  value={selectedQuickReplyOption}
                  hideSelectedOptions={false}
                  isMulti
                  components={{ Option }}
                  styles={{
                    ...buttonType,
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  classNamePrefix="select"
                  placeholder="Select button"
                  onChange={handleQuickReplySelect}
                  menuPortalTarget={document.body}
                />

                {selectedQuickReplyOption.map((option) => {
                  if (option.value === 'button1') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton1}
                          name="button1"
                          value={button1.button1}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 1"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button2') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton2}
                          name="button2"
                          value={button2.button2}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 2"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button3') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton3}
                          name="button3"
                          value={button3.button3}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 3"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button4') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton4}
                          name="button4"
                          value={button4.button4}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 4"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button5') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton5}
                          name="button5"
                          value={button5.button5}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 5"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button6') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton6}
                          name="button6"
                          value={button6.button6}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 6"
                        />
                      </div>
                    );
                  }
                  if (option.value === 'button7') {
                    return (
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          onChange={onChangeButton7}
                          name="button7"
                          value={button7.button7}
                          maxLength={20}
                          className="form-control"
                          placeholder="button 7"
                        />
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          )}

          {buttonType.flow && (
            <div className="call-action-area" style={{ position: 'relative', zIndex: 1 }}>
              <div className="row">
                <div className="col-md-4 drop-down-icons">
                  <select
                    name="flowNavigateScreen"
                    value={flowAction.flowNavigateScreen}
                    onChange={handleFlowSelect}
                    className="form-control"
                    disabled={flowsLoading}
                  >
                    <option value="">{flowsLoading ? "Loading flows..." : "Select Flow"}</option>
                    {flows.map((flow) => (
                      <option key={flow.meta_flow_id} value={flow.meta_flow_id}>
                        {flow.flow_title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    name="flow_id"
                    value={flowAction.flow_id}
                    onChange={flowHandler}
                    placeholder="Flow ID"
                    readOnly
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <input
                    type="text"
                    className="form-control"
                    name="text"
                    value={flowAction.text}
                    onChange={flowHandler}
                    placeholder="Button Text"
                    maxLength={20}
                    disabled={!flowAction.flow_id}
                  />
                </div>
              </div>

              {/* <div
                style={{
                  marginTop: "14px",
                  border: "1px solid #dee2e6",
                  borderRadius: "8px",
                  padding: "12px 16px",
                  background: "#f8f9fa",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: "13px",
                        color: "#343a40",
                        display: "block",
                        marginBottom: "2px",
                      }}
                    >
                      Contact List
                    </span>
                    <span style={{ fontSize: "11px", color: "#6c757d" }}>
                      Enable to add Contact data in list.
                    </span>
                  </div>
                  <label className="switch" style={{ marginBottom: 0 }}>
                    <input
                      type="checkbox"
                      checked={enableFlowOption}
                      onChange={() => {
                        const next = !enableFlowOption;
                        setEnableFlowOption(next);
                        setFlowOptionValue("");
                        if (next && contactList.length === 0) {
                          fetchContactList();
                        }
                      }}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>

                {enableFlowOption && (
                  <div style={{ marginTop: "12px" }}>
                    <label
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#495057",
                        marginBottom: "5px",
                        display: "block",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                      }}
                    >
                      Select Contact List
                    </label>
                    <div className="drop-down-icons">
                      <select
                        className="form-control"
                        value={flowOptionValue}
                        onChange={(e) => setFlowOptionValue(e.target.value)}
                        disabled={contactListLoading}
                        style={{ fontSize: "13px", borderRadius: "6px" }}
                      >
                        <option value="">
                          {contactListLoading ? "Loading..." : "Select Contact List"}
                        </option>
                        {contactList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div> */}
            </div>
          )}

          {/* <div className="text-right mt-2">
            <button className="btn btn-sm btn-success" onClick={setButtonValue}>Save</button>
          </div> */}
        </>
      )}
    </>
  );
}

export default NewButton;
